import { Component, Input, ViewChild, Renderer2, ElementRef, ViewEncapsulation } from '@angular/core'

@Component({
    selector: 'plain-text',
    templateUrl: './renderPlainText.component.html',
    styleUrls: ['./renderPlainText.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class RenderPlainText {

    @Input() data: any;

    @Input() ctaArray: any;

    @ViewChild('chatMessage', {static: true}) chatMessage;

    @ViewChild('chatMessageItem', {static: true}) chatMessageItem;

    // @ViewChild('messageContentInit') messageContentInit;

    constructor(
        private _r: Renderer2,
        private _eL: ElementRef
    ) {

    }

    ngOnInit() {
        this.animationStart();
    }

    ngAfterViewInit() {
        this.checkParent();
    }

    /**
     * confere se o elemento de TEXTO anterior veio do bot
     */
    checkParent() {
        let parent = this._eL.nativeElement.previousElementSibling;

        if (parent && parent.tagName == "PLAIN-TEXT") {
            if (parent.firstChild.classList.contains("chat-message--left")) {
                this._r.addClass(this.chatMessage.nativeElement, 'text-sequence');
            }
        }
    }

    /**
     * seta time para as animacoes, entrada na tela e apos o loading do texto
     */
    animationStart() {
        // entrada
        setTimeout(() => {
            this._r.addClass(this.chatMessageItem.nativeElement, 'on-entry');
        }, 600);

        // loading texto
        setTimeout(() => {
            this._r.addClass(this.chatMessageItem.nativeElement, 'after-loading');
        }, 2500);
    }
}
